import { labs } from 'kb-shared/utilities/lab.helper';

const FULL_NPV_BLOCK_MARKET_IDS = [labs().DALLAS, labs().MINNEAPOLIS, labs().PRINCETON];

export const shouldHideInClinicNpvSlots = ({
  flagOn,
  patientFacing,
  labId,
  newPatientVisit
}: {
  flagOn: boolean;
  patientFacing?: boolean;
  labId?: string;
  newPatientVisit: boolean;
}) =>
  flagOn &&
  patientFacing === false &&
  newPatientVisit &&
  !FULL_NPV_BLOCK_MARKET_IDS.includes(labId ?? '');
